import { Footer } from '@/components/Footer';
import dkLogo from '@/assets/damian-keyes-logo.png';

export default function LetsGo() {
  return (
    <div className="min-h-screen bg-white text-gray-900 flex flex-col">
      {/* Header */}
      <header className="flex justify-start px-5 lg:px-8 py-5 lg:py-6">
        <img src={dkLogo} alt="DK Music Academy" className="h-11 lg:h-12 w-auto brightness-0" />
      </header>

      <main className="flex-1 flex flex-col items-center px-5 pb-16 lg:pb-24">
        {/* Badge */}
        <span className="font-bold text-sm tracking-wide uppercase px-5 py-2 rounded-lg border border-gray-300 text-gray-500 mb-8">
          LETS GO 🚀
        </span>

        {/* Headline */}
        <h1 className="text-[32px] lg:text-[44px] leading-tight font-extrabold text-center max-w-2xl mb-4">
          You're all set.{' '}
          <span className="inline-block px-3 py-1 rounded-lg" style={{ backgroundColor: '#FFD700' }}>
            Check your inbox
          </span>{' '}
          📩
        </h1>

        <p className="text-gray-500 text-center text-[15px] lg:text-base leading-relaxed max-w-md mb-8">
          Your release plan is on its way now. It can take up to a minute to arrive.
        </p>

        {/* If you don't see it */}
        <div className="w-full max-w-md bg-gray-50 rounded-xl p-5 mb-12">
          <p className="font-semibold text-sm mb-3">If you don't see it:</p>
          <ul className="space-y-2 text-sm text-gray-600">
            <li className="flex items-center gap-2">
              <span className="text-base">📂</span> Check spam or junk
            </li>
            <li className="flex items-center gap-2">
              <span className="text-base">🔍</span> Search "Damian Keyes"
            </li>
            <li className="flex items-center gap-2">
              <span className="text-base">📧</span> Check promotions tab
            </li>
          </ul>
        </div>

        {/* Divider */}
        <div className="w-16 h-px bg-gray-200 mb-12" />

        {/* Next Steps */}
        <div className="w-full max-w-3xl flex flex-col items-center">
          <h2 className="text-[24px] lg:text-[28px] font-bold text-center mb-2">Next Steps</h2>
          <p className="text-sm lg:text-base text-gray-500 text-center mb-8 max-w-md">
            If you're serious about growing your music, start learning the full system inside DK-MBA.
          </p>

          <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-4">
            Watch how artists go from zero to 1 million streams
          </p>

          <div className="relative w-full rounded-2xl overflow-hidden shadow-xl mb-8" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://player.vimeo.com/video/777173715?autoplay=0&loop=0&muted=0"
              className="absolute top-0 left-0 w-full h-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="DK-MBA Academy overview"
            />
          </div>

          <a
            href="https://www.dk-mba.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center w-full max-w-sm h-14 bg-black text-white font-bold text-lg rounded-lg hover:bg-gray-900 hover:shadow-lg active:scale-[0.98] transition-all duration-150 relative overflow-hidden"
          >
            <span className="absolute inset-0 animate-btn-shimmer bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full" />
            <span className="relative flex items-center justify-center gap-1">
              Explore The System
              <span className="inline-block transition-transform duration-200 group-hover:translate-x-1">→</span>
            </span>
          </a>
        </div>
      </main>

      <Footer />
    </div>
  );
}
